import { Pipe, PipeTransform } from '@angular/core';
import { MitigationPlanFrequencySource } from '../../viewmodels/analysis/mitigation-plan-frequency-source';

@Pipe({
  name: 'mitigationPlanTaskFrequency',
})
export class MitigationPlanTaskFrequencyPipe implements PipeTransform {
  /**
   * Returns the correct display text for a given frequencySource value.
   * @param {MitigationPlanFrequencySource} value The value to convert.
   * @returns {string} The text to be displayed.
   */
  public transform(value: MitigationPlanFrequencySource): string {
    switch (value) {
      case MitigationPlanFrequencySource.CmlDueDate:
        return 'CML Due Date';
      case MitigationPlanFrequencySource.ThicknessRemainingHalfLife:
        return 'Remaining Half-life';
      case MitigationPlanFrequencySource.CriticalityEstimatedHalfLife:
        return 'Criticality Estimated Half-life';
      case MitigationPlanFrequencySource.Overridden:
        return 'Overridden';
      case MitigationPlanFrequencySource.FactoredRemainingLife:
        return 'Factored Remaining Life';
      case MitigationPlanFrequencySource.RecommendationFrequency:
        return 'Recommendation';
      case MitigationPlanFrequencySource.MaxInspectionFrequency:
        return 'Max Inspection Frequency';
    }
  }
}
